import * as React from "react";
import { Container, Grid } from "@material-ui/core";
import TextEditor from "./Editor";
import IcoLightBulb from "./IcoLightBulb";
import { showEditIconBlue } from "../server/constants";

interface DidYouKnowProps {
  didYouKnow: any,
  didYouKnowDescendantText: any
}

function DidYouKnow(props: DidYouKnowProps) {
  const {didYouKnow, didYouKnowDescendantText} = props;
  return (
    <Container maxWidth="lg">
      <div className="sectionPD">
        <Grid container spacing={3} justifyContent="center" alignItems="center">
          <Grid item xs={12} md={4} lg={2} className="textCenter">
            <IcoLightBulb/>
          </Grid>
          <Grid item xs={12} md={8} lg={10}>

            <TextEditor color="primary"
                        content={didYouKnow}
                        sectionId={"didYouKnow"}
                        upperDivClass={showEditIconBlue}
            />


            <TextEditor className="textLightBlack"
                        content={didYouKnowDescendantText}
                        sectionId="didYouKnowDescendantText"
                        upperDivClass={showEditIconBlue}
            />

          </Grid>
        </Grid>
      </div>
    </Container>
  )
}

export default DidYouKnow;
